import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import ADGMImage from '../ADGMImage';

import styles from './styles';
import './style.css';

class CustomSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultSelectText: '',
      showOptionList: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    const { defaultText } = this.props;
    this.setState({
      defaultSelectText: defaultText,
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = e => {
    if (!e.target.classList.contains('custom-select-option') && !e.target.classList.contains('selected-text')) {
      this.setState({
        showOptionList: false,
      });
    }
  };

  handleListDisplay = () => {
    this.setState(prevState => ({
      showOptionList: !prevState.showOptionList,
    }));
  };

  handleOptionClick = e => {
    const { onChange } = this.props;

    this.setState({
      defaultSelectText: e.target.getAttribute('data-name'),
      showOptionList: false,
    });

    onChange && onChange(e);
  };

  render() {
    const { optionsList, classes, type, name, fieldId } = this.props;
    const { showOptionList, defaultSelectText } = this.state;

    return (
      <div className='custom-select-container'>
        <div
          className={showOptionList ? 'selected-text active' : 'selected-text'}
          onClick={this.handleListDisplay}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
          role='button'
          onKeyPress={this.handleListDisplay}
          tabIndex={0}
        >
          <span>{defaultSelectText}</span>
        </div>
        {showOptionList && type === 'dropdown' && (
          <ul className='selectedSubmenu' name={name}>
            {optionsList.map(option => (
              <li
                className='custom-select-option'
                data-name={option.name}
                data-id={option.id}
                data-key={fieldId}
                key={option.id}
                onClick={this.handleOptionClick}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                role='button'
                onKeyPress={this.handleOptionClick}
                tabIndex={0}
              >
                {option.name}
              </li>
            ))}
          </ul>
        )}
        {showOptionList && type === 'pillGroup' && (
          <ul className='selectedSubmenu bedroomSubmenu'>
            {optionsList.map(option => (
              <li
                className='custom-select-option'
                data-name={option.name}
                data-id={option.id}
                data-key={fieldId}
                key={option.id}
                onClick={this.handleOptionClick}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                role='button'
                onKeyPress={this.handleOptionClick}
                tabIndex={0}
              >
                {option.name}
              </li>
            ))}
          </ul>
        )}
        {showOptionList && type === 'select' && (
          <div className='selectedSubmenu recentSearchesSubmenu'>
            <Autocomplete
              freeSolo
              id='free-solo-2-demo'
              disableClearable
              className={classes.autocompleteHolder}
              options={optionsList.map(option => option.name)}
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder='example: Yas Island'
                  variant='outlined'
                  className={classes.searchInputHolder}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                    startAdornment: (
                      <InputAdornment position='start'>
                        <ADGMImage name='searchbar.svg' alt='search-icon' className={classes.searchIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
            <span className='fontweightmedium'>Recent searches</span>
            <ul className={classes.searchitemList}>
              {optionsList.map(option => (
                <li
                  className='custom-select-option'
                  data-name={option.name}
                  key={option.id}
                  onClick={this.handleOptionClick}
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role='button'
                  onKeyPress={this.handleOptionClick}
                  tabIndex={0}
                >
                  {option.name}
                </li>
              ))}
            </ul>
          </div>
        )}
        {showOptionList && type === 'checkbox' && (
          <div className='selectedSubmenu MortgageSubmenu'>
            <FormControl component='fieldset'>
              <RadioGroup aria-label='Mortgage' name='Mortgage1' className={classes.checkboxholder}>
                {optionsList.map(item => (
                  <FormControlLabel value={item.id} control={<Radio />} label={item.name} />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
        )}
      </div>
    );
  }
}

CustomSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  defaultText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fieldId: PropTypes.string,
  optionsList: PropTypes.array.isRequired,
  type: PropTypes.oneOf(['checkbox', 'select', 'pillGroup', 'dropdown']),
  onChange: PropTypes.func.isRequired,
};

CustomSelect.defaultProps = {
  type: 'dropdown',
  fieldId: null,
};

export default withStyles(styles)(CustomSelect);
